/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.BaseFilterView = app.View.extend({
    sendChangeEvent: function (e) {
      Backbone.trigger('filter-was-chosen', e, this.model.get('object'));
    },
    /**
     * Обработчик клика на body
     * @param e
     */
    bodyClick: function (e) {
      var needToClose = this.popupOpen && !$(e.target).closest('.prevent-close-popup').length;
      if (needToClose) {
        this.hidePopup();
        this.arrowSelectDown();
      }
    }
  });
})();

}.call(window));